/**
 * Type Beauty wishlist — cookie-backed handles, heart toggle on product cards,
 * wishlist page hydrates cards from /products/{handle}.js
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'tb_wishlist';
  var COOKIE_MAX_DAYS = 365;
  var MAX_ITEMS = 50;

  function i18n(key) {
    var bundle = window.TB_WISHLIST_I18N || {};
    return bundle[key] || '';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax';
  }

  function dedupeHandles(arr) {
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var h = String(arr[i] || '').trim().toLowerCase();
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out;
  }

  function getHandles() {
    try {
      var raw = getCookie(COOKIE_NAME);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return dedupeHandles(parsed).slice(0, MAX_ITEMS);
    } catch (e) {
      return [];
    }
  }

  function saveHandles(handles) {
    var clean = dedupeHandles(handles).slice(0, MAX_ITEMS);
    setCookie(COOKIE_NAME, JSON.stringify(clean), COOKIE_MAX_DAYS);
    return clean;
  }

  function isWishlisted(handle) {
    if (!handle) return false;
    var h = String(handle).toLowerCase();
    return getHandles().indexOf(h) !== -1;
  }

  /** @returns {boolean} true if handle is in list after toggle */
  function toggleHandle(handle) {
    var h = String(handle || '').toLowerCase().trim();
    if (!h) return false;
    var list = getHandles();
    var idx = list.indexOf(h);
    if (idx === -1) {
      list.push(h);
      saveHandles(list);
      return true;
    }
    list.splice(idx, 1);
    saveHandles(list);
    return false;
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function escapeAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function wishlistLoadingHTML() {
    var label = i18n('loading') || 'Loading wishlist';
    return (
      '<div class="tb-wishlist__loading" role="status" aria-live="polite" aria-busy="true">' +
      '<span class="tb-wishlist__spinner" aria-hidden="true"></span>' +
      '<span class="visually-hidden">' +
      escapeHtml(label) +
      '</span></div>'
    );
  }

  function priceToCents(v) {
    if (!v || v.price == null) return 0;
    var p = v.price;
    if (typeof p === 'string') {
      if (p.indexOf('.') !== -1) {
        var n = parseFloat(p);
        return isNaN(n) ? 0 : Math.round(n * 100);
      }
      return parseInt(p, 10) || 0;
    }
    return Math.round(Number(p)) || 0;
  }

  function compareToCents(v) {
    if (!v || v.compare_at_price == null || v.compare_at_price === '') return 0;
    var fake = { price: v.compare_at_price };
    return priceToCents(fake);
  }

  function formatMoney(cents) {
    if (window.KROWN && KROWN.helpers && KROWN.settings && KROWN.settings.shop_money_format) {
      return KROWN.helpers.formatMoney(cents, KROWN.settings.shop_money_format);
    }
    return (cents / 100).toFixed(2);
  }

  var COLOR_OPTION_NAMES = 'color,colour,couleur,colore,culoare,farbe,색,色,カラー,färg,farve'.split(',');

  function normalizeImageEntry(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object' && raw.preview_image) {
      return normalizeImageEntry(raw.preview_image);
    }
    if (typeof raw === 'string') {
      var s = String(raw).trim();
      if (!s) return null;
      if (s.indexOf('//') === 0) s = 'https:' + s;
      else if (s.charAt(0) === '/' && s.indexOf('//') !== 0) {
        s = (typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : '') + s;
      }
      return { src: s, alt: '', width: 0, height: 0, aspect_ratio: null };
    }
    if (typeof raw !== 'object' || raw === null) return null;
    var src = raw.src || raw.url;
    if ((!src || typeof src !== 'string') && raw.sources && raw.sources.length && raw.sources[0].url) {
      src = raw.sources[0].url;
    }
    if (!src || typeof src !== 'string') return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var w = Number(raw.width) || 0;
    var h = Number(raw.height) || 0;
    var ar = raw.aspect_ratio != null ? Number(raw.aspect_ratio) : null;
    if ((!ar || ar <= 0) && w > 0 && h > 0) ar = w / h;
    return { src: src, alt: raw.alt || '', width: w, height: h, aspect_ratio: ar };
  }

  function collectProductImages(product) {
    var out = [];
    var seen = {};
    function add(raw) {
      var n = normalizeImageEntry(raw);
      if (!n || !n.src) return;
      if (seen[n.src]) return;
      seen[n.src] = true;
      out.push(n);
    }
    if (product.featured_image != null && product.featured_image !== '') add(product.featured_image);
    if (product.image != null && product.image !== '') add(product.image);
    if (product.images && product.images.length) {
      for (var i = 0; i < product.images.length; i++) add(product.images[i]);
    }
    if (product.media && product.media.length) {
      for (var m = 0; m < product.media.length; m++) {
        var med = product.media[m];
        if (!med) continue;
        if (med.media_type && med.media_type !== 'image') continue;
        if (med.preview_image) add(med.preview_image);
        else add(med);
      }
    }
    if (!out.length && product.variants) {
      for (var j = 0; j < product.variants.length; j++) {
        var v = product.variants[j];
        if (!v) continue;
        if (v.featured_image) add(v.featured_image);
        if (v.featured_media) {
          if (v.featured_media.preview_image) add(v.featured_media.preview_image);
          add(v.featured_media);
        }
      }
    }
    return out;
  }

  function shopifyImageWidth(src, width) {
    if (!src || !width) return src;
    var sep = src.indexOf('?') >= 0 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function figureRatio(imgEntry) {
    var g = window.TB_WISHLIST_GRID_RATIO;
    if (g && g !== 'natural') {
      var n = parseFloat(g, 10);
      if (n > 0) return n;
    }
    if (imgEntry && imgEntry.aspect_ratio && imgEntry.aspect_ratio > 0) return imgEntry.aspect_ratio;
    if (imgEntry && imgEntry.width > 0 && imgEntry.height > 0) return imgEntry.width / imgEntry.height;
    return 0.83333;
  }

  function buildLazyFigure(imgEntry, altText) {
    var ratio = figureRatio(imgEntry);
    var ratioAttr = ratio > 0 ? ' data-ratio="' + ratio + '"' : '';
    var ratioStyle = ratio > 0 ? ' style="padding-top:' + 100 / ratio + '%"' : '';
    var src480 = shopifyImageWidth(imgEntry.src, 480);
    var isPng = imgEntry.src.toLowerCase().indexOf('.png') !== -1;
    var w = imgEntry.width > 0 ? String(Math.min(imgEntry.width, 480)) : '480';
    var h =
      imgEntry.height > 0
        ? String(Math.min(imgEntry.height, Math.round(480 / ratio)))
        : String(Math.round(480 / ratio));
    return (
      '<figure data-crop="true" class="lazy-image animation' +
      (isPng ? ' lazy-image--transparent' : '') +
      '"' +
      ratioAttr +
      ratioStyle +
      '><img class="img lazy" width="' +
      w +
      '" height="' +
      h +
      '" src="' +
      escapeAttr(src480) +
      '" alt="' +
      escapeAttr(altText || imgEntry.alt || '') +
      '" loading="lazy"/></figure>'
    );
  }

  function buildMediaSlides(product, titlePlain) {
    var imgs = collectProductImages(product);
    if (!imgs.length) {
      return { html: '<div class="tb-pcard__slide"><span class="tb-pcard__placeholder"></span></div>', count: 0 };
    }
    var parts = [];
    for (var i = 0; i < imgs.length; i++) {
      parts.push('<div class="tb-pcard__slide">' + buildLazyFigure(imgs[i], titlePlain) + '</div>');
    }
    return { html: parts.join(''), count: imgs.length };
  }

  function isColorOptionName(name) {
    if (!name) return false;
    var d = String(name).toLowerCase().trim();
    for (var i = 0; i < COLOR_OPTION_NAMES.length; i++) {
      if (COLOR_OPTION_NAMES[i] === d) return true;
    }
    return false;
  }

  function findColorOption(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var name = typeof o === 'string' ? o : o && o.name;
      var position = typeof o === 'object' && o && o.position != null ? o.position : i + 1;
      if (isColorOptionName(name)) {
        return {
          option: typeof o === 'object' && o ? o : { name: name, position: position, values: [] },
          position: position,
        };
      }
    }
    return null;
  }

  function optionValues(product, position) {
    var opts = product.options || [];
    var opt = null;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].position === position) {
        opt = opts[i];
        break;
      }
    }
    if (opt && opt.values && opt.values.length) return opt.values;
    var key = 'option' + position;
    var seen = {};
    var out = [];
    var variants = product.variants || [];
    for (var v = 0; v < variants.length; v++) {
      var val = variants[v][key];
      if (val == null || val === '') continue;
      if (!seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    }
    return out;
  }

  function firstVariantForOptionValue(product, position, value) {
    var key = 'option' + position;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i][key] === value) return variants[i];
    }
    return null;
  }

  function buildColorShadesHTML(product, url) {
    var meta = findColorOption(product);
    if (!meta) return { html: '', hadShades: false };
    var values = optionValues(product, meta.position);
    if (!values.length) return { html: '', hadShades: false };

    var showImg = !!window.TB_WISHLIST_SHOW_VARIANT_IMAGE;
    var limit = Math.min(5, values.length);

    if (showImg) {
      var parts = ['<div class="tb-pcard__shades" role="group" aria-label="Shades"><product-item-variants class="tb-pcard__shade-list">'];
      var uIndex = 0;
      var isFirst = true;
      for (var i = 0; i < limit; i++) {
        var value = values[i];
        var variant = firstVariantForOptionValue(product, meta.position, value);
        if (!variant) continue;
        var active = isFirst ? ' active' : '';
        isFirst = false;
        var fi = variant.featured_image ? normalizeImageEntry(variant.featured_image) : null;
        var layerHtml = '';
        if (fi) {
          layerHtml =
            '<div class="product-item__variant-image tb-pcard__variant-layer" style="display:none" data-id="' +
            uIndex +
            '">' +
            buildLazyFigure(fi, product.title) +
            '</div>';
        }
        var shadeBg = String(value).toLowerCase().replace(/\s+/g, '');
        parts.push(
          '<div class="product-item__variant tb-pcard__shade' +
          active +
          '" data-varid="' +
          escapeAttr(String(variant.id)) +
          '" data-href="' +
          escapeAttr(url + '?variant=' + variant.id) +
          '" data-id="' +
          uIndex +
          '" role="button" tabindex="0"><p class="tb-pcard__shade-tooltip">' +
          escapeHtml(String(value)) +
          '</p><span class="visually-hidden">' +
          escapeHtml(String(value)) +
          '</span><span class="tb-pcard__shade-visual" style="background-color:' +
          escapeAttr(shadeBg) +
          '"></span>' +
          layerHtml +
          '</div>'
        );
        uIndex++;
      }
      parts.push('</product-item-variants>');
      if (values.length > 5) {
        parts.push('<a class="tb-pcard__shades-more" href="' + escapeAttr(url) + '">Explore more shades &gt;</a>');
      }
      parts.push('</div>');
      return { html: parts.join(''), hadShades: true };
    }

    var parts2 = ['<div class="tb-pcard__shades" role="group" aria-label="Shades"><div class="tb-pcard__shade-list tb-pcard__shade-list--anchors">'];
    var fv = values[0];
    var fvVar = firstVariantForOptionValue(product, meta.position, fv);
    if (fvVar) {
      parts2.push(
        '<div class="product-item__variant tb-pcard__shade tb-pcard__shade--anchor-fallback visually-hidden active" aria-hidden="true" data-varid="' +
        escapeAttr(String(fvVar.id)) +
        '" data-href="' +
        escapeAttr(url + '?variant=' + fvVar.id) +
        '" data-id="0"></div>'
      );
    }
    for (var j = 0; j < limit; j++) {
      var val2 = values[j];
      var var2 = firstVariantForOptionValue(product, meta.position, val2);
      if (!var2) continue;
      var shadeBg2 = String(val2).toLowerCase().replace(/\s+/g, '');
      parts2.push(
        '<a class="tb-pcard__shade tb-pcard__shade--anchor" href="' +
        escapeAttr(url + '?variant=' + var2.id) +
        '" title="' +
        escapeAttr(String(val2)) +
        '"><span class="tb-pcard__shade-visual" style="background-color:' +
        escapeAttr(shadeBg2) +
        '"></span></a>'
      );
    }
    parts2.push('</div>');
    if (values.length > 5) {
      parts2.push('<a class="tb-pcard__shades-more" href="' + escapeAttr(url) + '">Explore more shades &gt;</a>');
    }
    parts2.push('</div>');
    return { html: parts2.join(''), hadShades: true };
  }

  function hasOnlyDefaultVariant(product) {
    var v = product.variants || [];
    return v.length === 1 && v[0].title === 'Default Title';
  }

  function isComboStyleProduct(handle) {
    var combos = ['eyeshadow-combo-1', 'lipstick-combo', 'lipstick-combo-1', 'eyeshadow-combo-2'];
    for (var c = 0; c < combos.length; c++) {
      if (handle === combos[c]) return true;
    }
    return false;
  }

  function atcModifierClasses(handle) {
    var cls = '';
    if (handle === 'get-even-serum-foundation' || handle === 'get-even-primer') cls += ' product__add-to-cart_v1';
    if (handle === 'matte-up-balancing-primer' || handle === 'matte-up-foundation') cls += ' product__add-to-cart_v2';
    if (handle === 'calm-on-foundation' || handle === 'calm-on-hydrating-gel-primer') cls += ' product__add-to-cart_v3';
    if (handle === 'over-dew-primer' || handle === 'decrease-foundation') cls += ' product__add-to-cart_v4';
    return cls;
  }

  function syncWishlistButton(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var on = isWishlisted(handle);
    btn.classList.toggle('is-wishlisted', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? i18n('remove') : i18n('add'));
  }

  function syncAllWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncWishlistButton);
  }

  function syncHeaderWishlistCount() {
    var all = document.querySelectorAll('[data-header-wishlist-count]');
    if (!all.length) return;
    var n = getHandles().length;
    var text = String(n);
    all.forEach(function (el) {
      el.textContent = text;
      if (n > 0) {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /** If the theme served cached/old header HTML without the wishlist row, insert it (matches menu-meta pattern). */
  function ensureHeaderWishlistNav() {
    var ul =
      document.querySelector('main-header .menu-meta ul') ||
      document.querySelector('.header-holder .menu-meta ul') ||
      document.querySelector('.header .menu-meta ul');
    if (!ul) return;
    if (ul.querySelector('[data-tb-wishlist-header-nav]')) return;
    if (ul.querySelector('a.menu-meta__link[href*="wishlist"]')) return;

    var href = window.TB_WISHLIST_PAGE_URL || '/pages/wishlist';
    var label = i18n('wishlistNav') || 'Wishlist';
    var heartSvg =
      '<svg class="tb-wishlist-header-icon" width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="white" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/></svg>';

    var li = document.createElement('li');
    li.setAttribute('data-tb-wishlist-header-nav', '');
    li.innerHTML =
      '<a class="menu-meta__link" href="' +
      escapeAttr(href) +
      '">' +
      '<span class="menu-meta__icon menu-meta__icon--tb-wishlist" aria-label="' +
      escapeAttr(label) +
      '" role="img" style="margin-top: -1px;">' +
      heartSvg +
      '<span class="menu-meta__count" data-header-wishlist-count hidden aria-hidden="true">0</span>' +
      '</span>' +
      '<span class="lap--hide menu-meta__text">' +
      escapeHtml(label) +
      '</span>' +
      '</a>';

    var cartBtn = document.getElementById('cart-open-button');
    var cartLi = cartBtn && cartBtn.closest('li');
    if (cartLi && cartLi.parentNode === ul) {
      ul.insertBefore(li, cartLi);
    } else {
      ul.appendChild(li);
    }
  }

  function firstAvailableVariant(variants) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0];
  }

  function buildWishlistCardHTML(product, visualIndex) {
    var handle = product.handle;
    var title = escapeHtml(product.title);
    var titlePlain = product.title || '';
    var url = '/products/' + encodeURIComponent(handle);
    var variants = product.variants || [];
    var first = firstAvailableVariant(variants);
    var order = (visualIndex % 20) + 1;
    var anim = window.TB_WISHLIST_CARD_ANIMATION || 'product-item--zoom';

    var prices = variants.map(priceToCents);
    if (!prices.length) prices = [0];
    var minPrice = Math.min.apply(null, prices);
    var maxPrice = Math.max.apply(null, prices);
    var priceVaries =
      product.price_varies === true || (product.price_min != null && product.price_max != null && product.price_min !== product.price_max) || minPrice !== maxPrice;

    if (product.price_min != null && product.price_max != null) {
      minPrice = priceToCents({ price: product.price_min });
      maxPrice = priceToCents({ price: product.price_max });
    }

    var priceHtml = '';
    if (priceVaries) {
      priceHtml =
        '<span class="tb-pcard__price-current">' +
        escapeHtml(i18n('from')) +
        ' ' +
        formatMoney(minPrice) +
        '</span>';
    } else if (first) {
      var pc = priceToCents(first);
      var cc = compareToCents(first);
      priceHtml =
        '<span class="visually-hidden">Price</span><span class="tb-pcard__price-current">' +
        formatMoney(pc) +
        '</span>';
      if (cc > pc) {
        priceHtml += '<del class="tb-pcard__price-compare">' + formatMoney(cc) + '</del>';
      }
    }

    var soldBadge = '';
    if (!product.available) {
      soldBadge =
        '<div class="tb-pcard__badge tb-pcard__badge--sold text-size--small"><span>' +
        escapeHtml(i18n('soldOut')) +
        '</span></div>';
    }

    var shadePack = buildColorShadesHTML(product, url);
    var hadShades = shadePack.hadShades;

    var mod = atcModifierClasses(handle);

    var ctaRow = '';
    if (first && first.available) {
      var useForm = hasOnlyDefaultVariant(product) && !isComboStyleProduct(handle);
      if (useForm) {
        ctaRow =
          '<form class="tb-pcard__form tb-pcard__form--cta" method="post" action="/cart/add" data-add-to-cart-cta>' +
          '<input type="hidden" name="id" class="item-varid" value="' +
          escapeAttr(String(first.id)) +
          '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="button" class="tb-pcard__cta-row col-add-btn js-atc' +
          mod +
          '">' +
          '<span class="tb-pcard__price">' +
          priceHtml +
          '</span>' +
          '<span class="tb-pcard__cta-label tb-btn__text">' +
          escapeHtml(i18n('addToCart')) +
          '</span></button></form>';
      } else if (isComboStyleProduct(handle)) {
        ctaRow =
          '<a href="' +
          escapeAttr(url) +
          '" class="tb-pcard__cta-row tb-pcard__cta-row--link" data-add-to-cart-cta>' +
          '<span class="tb-pcard__price">' +
          priceHtml +
          '</span>' +
          '<span class="tb-pcard__cta-label tb-btn__text">' +
          escapeHtml(i18n('addToCart')) +
          '</span></a>';
      } else {
        ctaRow =
          '<button type="button" class="tb-pcard__cta-row tb-pcard__cta-row--quickshop product-item-quickview" data-handle="' +
          escapeAttr(url) +
          '" data-add-to-cart-cta>' +
          '<span class="tb-pcard__price">' +
          priceHtml +
          '</span>' +
          '<span class="tb-pcard__cta-label tb-btn__text">Quick Shop</span></button>';
      }
    } else {
      ctaRow =
        '<a href="' +
        escapeAttr(url) +
        '" class="tb-pcard__cta-row tb-pcard__cta-row--link">' +
        '<span class="tb-pcard__price">' +
        priceHtml +
        '</span>' +
        '<span class="tb-pcard__cta-label tb-btn__text">' +
        escapeHtml(i18n('viewProduct')) +
        '</span></a>';
    }

    var defaultHidden = '';
    if (hasOnlyDefaultVariant(product) && first) {
      defaultHidden =
        '<input type="hidden" class="product-item__variant tb-pcard__variant-input active" value="' +
        escapeAttr(String(first.id)) +
        '" data-varid="' +
        escapeAttr(String(first.id)) +
        '">';
    }

    var fallbackShade = '';
    if (!hadShades && variants.length > 1 && variants[0] && variants[0].title !== 'Default Title' && first) {
      fallbackShade =
        '<div class="product-item__variant tb-pcard__shade-fallback visually-hidden active" aria-hidden="true" data-varid="' +
        escapeAttr(String(first.id)) +
        '" data-href="' +
        escapeAttr(url + '?variant=' + first.id) +
        '" data-id="0"></div>';
    }

    var shellInner = defaultHidden + shadePack.html + fallbackShade + ctaRow;

    var media = buildMediaSlides(product, titlePlain);
    var trackClass = 'tb-pcard__track' + (media.count <= 1 ? ' tb-pcard__track--single' : '');

    var galleryNavHtml =
      media.count > 1
        ? '<div class="tb-pcard__gallery-nav" data-pcard-gallery-nav>' +
          '<button type="button" class="tb-pcard__gallery-nav-btn tb-pcard__gallery-prev" aria-label="Previous image">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
          '<path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="tb-pcard__gallery-nav-btn tb-pcard__gallery-next" aria-label="Next image">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
          '<path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
          '<div class="tb-pcard__gallery-progress" data-pcard-gallery-progress hidden>' +
          '<div class="tb-pcard__gallery-progress-bar" role="progressbar" aria-label="Image gallery progress" aria-valuemin="1" aria-valuenow="1" aria-valuemax="1">' +
          '<span class="tb-pcard__gallery-progress-fill"></span></div></div>'
        : '';

    var qvSvg =
      '<svg class="tb-pcard__quickview-icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" stroke-width="1.75"></circle>' +
      '<path d="M16 16l4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"></path>' +
      '</svg>';

    return (
      '<article class="tb-pcard tb-pcard--wishlist-dynamic product-item three-tenths product-tablet--five-plus-tenths push-left-half-tenth order-' +
      order +
      ' ' +
      escapeAttr(anim) +
      ' ' +
      escapeAttr(handle) +
      ' recommended-pro" data-pcard-root data-index="' +
      visualIndex +
      '">' +
      '<div class="tb-pcard__corner-actions">' +
      '<button type="button" class="tb-pcard__wishlist is-wishlisted" data-wishlist-toggle data-product-handle="' +
      escapeAttr(handle) +
      '" aria-pressed="true" aria-label="' +
      escapeAttr(i18n('remove')) +
      '">' +
      '<svg class="tb-pcard__wishlist-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>' +
      '</svg></button>' +
      '<button type="button" class="tb-pcard__quickview product-item-quickview" data-handle="' +
      escapeAttr(url) +
      '" aria-label="' +
      escapeAttr(i18n('quickView')) +
      '">' +
      qvSvg +
      '</button></div>' +
      soldBadge +
      '<div class="tb-pcard__media-block">' +
      '<div class="tb-pcard__media" data-pcard-media>' +
      '<section class="' +
      trackClass +
      '">' +
      media.html +
      '</section></div>' +
      '<a class="tb-pcard__link tb-pcard__link--media-cover" href="' +
      escapeAttr(url) +
      '" data-pcard-link aria-label="' +
      escapeAttr(titlePlain) +
      '"></a>' +
      galleryNavHtml +
      '</div>' +
      '<a class="tb-pcard__link tb-pcard__link--text" href="' +
      escapeAttr(url) +
      '" data-pcard-link>' +
      '<div class="tb-pcard__body">' +
      '<h3 class="tb-pcard__title"><span class="tb-pcard__title-text">' +
      title +
      '</span></h3></div></a>' +
      '<div class="tb-pcard__shell product-item__caption">' +
      shellInner +
      '</div></article>'
    );
  }

  /** Only accept a real Type Beauty product card (avoids random <article> on full PDP HTML). */
  function parseWishlistCardArticleFromHtml(html) {
    if (!html || typeof html !== 'string') return null;
    var low = html.toLowerCase();
    if (low.indexOf('data-pcard-root') === -1 || low.indexOf('tb-pcard') === -1) return null;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var candidates = doc.querySelectorAll('article.tb-pcard[data-pcard-root], article[data-pcard-root].tb-pcard');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.querySelector('.tb-pcard__media') || el.querySelector('[data-pcard-media]')) {
          return el.outerHTML;
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function storefrontRootPath() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (r && typeof r === 'string') {
      return r.slice(-1) === '/' ? r : r + '/';
    }
    return '/';
  }

  function wishlistCardViewUrl(handle) {
    return storefrontRootPath() + 'products/' + encodeURIComponent(handle) + '?view=wishlist-card';
  }

  function productJsonUrl(handle) {
    return storefrontRootPath() + 'products/' + encodeURIComponent(handle) + '.js';
  }

  /** Prefer JSON template product.wishlist-card (layout none); fall back to Ajax JSON + JS HTML. */
  function fetchWishlistRow(handle) {
    return fetch(wishlistCardViewUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
    })
      .then(function (resp) {
        if (!resp.ok) return null;
        return resp.text();
      })
      .then(function (html) {
        var cardHtml = parseWishlistCardArticleFromHtml(html);
        if (cardHtml) return { mode: 'liquid', html: cardHtml, handle: handle };
        return fetch(productJsonUrl(handle), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
          if (!r.ok) return { mode: 'none', handle: handle };
          return r.json().then(function (p) {
            return { mode: 'ajax', product: p, handle: handle };
          });
        });
      });
  }

  function pruneMissingHandles(validHandles) {
    var current = getHandles();
    var next = current.filter(function (h) {
      return validHandles.indexOf(h) !== -1;
    });
    if (next.length !== current.length) saveHandles(next);
  }

  function mountWishlistPage() {
    var root = document.getElementById('tb-wishlist-page-root');
    if (!root) return;

    var grid = document.getElementById('tb-wishlist-grid');
    var empty = document.getElementById('tb-wishlist-empty');
    if (!grid) return;

    var handles = getHandles();
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = wishlistLoadingHTML();

    var anim = window.TB_WISHLIST_CARD_ANIMATION || 'product-item--zoom';

    Promise.all(handles.map(fetchWishlistRow))
      .then(function (rows) {
        var valid = [];
        var built = 0;
        grid.innerHTML = '';
        for (var i = 0; i < handles.length; i++) {
          var h = handles[i];
          var row = rows[i];
          if (!row) continue;

          if (row.mode === 'liquid' && row.html) {
            valid.push(h);
            grid.insertAdjacentHTML('beforeend', row.html);
            var list = grid.querySelectorAll('[data-pcard-root]');
            var lastCard = list[list.length - 1];
            if (lastCard) {
              if (anim && !lastCard.classList.contains(anim)) lastCard.classList.add(anim);
              lastCard.classList.add('order-' + ((built % 20) + 1));
              lastCard.setAttribute('data-index', String(built));
            }
            built++;
            continue;
          }

          if (row.mode === 'ajax' && row.product) {
            var p = row.product;
            if (String(p.handle).toLowerCase() !== String(h).toLowerCase()) {
              p = null;
              for (var j = 0; j < rows.length; j++) {
                if (
                  rows[j].mode === 'ajax' &&
                  rows[j].product &&
                  String(rows[j].product.handle).toLowerCase() === String(h).toLowerCase()
                ) {
                  p = rows[j].product;
                  break;
                }
              }
            }
            if (!p) continue;
            valid.push(h);
            grid.insertAdjacentHTML('beforeend', buildWishlistCardHTML(p, built));
            built++;
          }
        }
        pruneMissingHandles(valid);
        syncAllWishlistButtons();
        if (typeof window.preloadImages === 'function') {
          window.preloadImages(grid);
        }
        if (window.TypeBeautyPcardGallery && typeof window.TypeBeautyPcardGallery.initVisibleCards === 'function') {
          window.TypeBeautyPcardGallery.initVisibleCards();
        }
        if (!grid.querySelector('[data-pcard-root]') && empty) {
          empty.hidden = false;
        }
      })
      .catch(function () {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
      });
  }

  function onDocumentClick(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var nowListed = toggleHandle(handle);
    syncWishlistButton(btn);

    var grid = document.getElementById('tb-wishlist-grid');
    if (grid && !nowListed) {
      var card = btn.closest('[data-pcard-root]');
      if (card && grid.contains(card)) {
        card.remove();
        if (!grid.querySelector('[data-pcard-root]')) {
          var empty = document.getElementById('tb-wishlist-empty');
          if (empty) empty.hidden = false;
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('tb-wishlist:change', {
        detail: { handle: handle, listed: nowListed },
      })
    );
  }

  function init() {
    ensureHeaderWishlistNav();
    document.addEventListener('click', onDocumentClick, false);
    document.addEventListener('tb-wishlist:change', syncHeaderWishlistCount);
    syncAllWishlistButtons();
    syncHeaderWishlistCount();
    mountWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TBWishlist = {
    getHandles: getHandles,
    sync: syncAllWishlistButtons,
    isWishlisted: isWishlisted,
    reloadPage: mountWishlistPage,
    syncHeaderCount: syncHeaderWishlistCount,
  };
})();
